<template>
  <section>
    <header class="mb-3">
      <div class="d-none d-md-block">
        <ul
          class="nav nav-pills"
        >
          <li class="nav-item">
            <a
              class="nav-link"
              :class="{ active : !category }"
              href="#"
              @click.prevent="category = ''"
            >
              All Apps
            </a>
          </li>
          <li
            class="nav-item"
            v-for="(appCategory, index) in categories"
            :key="index"
          >
            <a
              class="nav-link"
              :class="{ active : category === appCategory}"
              href="#"
              @click.prevent="category = appCategory"
            >
              {{ appCategory }}
            </a>
          </li>
        </ul>
      </div>
      <div
        class="d-block d-md-none"
      >
        <select
          class="custom-select"
          v-model="category"
        >
          <option value="">All Apps</option>
          <option
            v-for="(category, i) in categories"
            :value="category"
          >{{ category }}</option>
        </select>
      </div>
    </header>
    <div class="row">
      <div
        v-for="(app, index) in filteredApps"
        :key="index"
        class="col-12 col-md-6 col-lg-4 mb-3"
      >
        <div class="card">
          <div class="card-body">
            <div class="media">
              <div class="media-left mr-3">
                <a
                  :href="'/apps/'+app.id"
                  class="d-block" style="width:40px;"
                >
                  <img :src="app.icon" width="40">
                </a>
              </div>
              <div class="media-body">
                <div class="mb-2">
                  <a
                    class="font-weight-bold text-truncate d-block"
                    :href="'/apps/'+app.id"
                  >
                    {{ app.name }}
                  </a>
                  <a
                    class="text-muted small d-block"
                    href="#"
                  >
                    {{ app.short_description }}
                  </a>
                </div>
                <hr>
                <button
                  v-if="!app.required"
                  :class="[
                    'btn btn-sm',
                    {
                      'btn-light muted': app.displayAsInstalled && app.isInstalled,
                      'btn-light': !app.displayAsInstalled && app.isInstalled,
                      'btn-primary': !app.isInstalled,
                    },
                  ]"
                  @click="updateLibrary(app, index)"
                  @mouseover="displayText(app, index, 'mouseover')"
                  @mouseout="displayText(app, index, 'mouseout')"
                >
                  <span
                    v-if="!app.loading"
                    :class="[
                      'text-uppercase',
                      {
                        'text-primary': app.isInstalled,
                      },
                    ]"
                  >
                    <i
                      v-if="app.isInstalled"
                      :class="[
                        'fa',
                        {
                          'fa-minus': !app.displayAsInstalled
                        },
                      ]"
                    ></i>
                    <i
                      v-else
                      class="fa fa-plus"
                    ></i>
                    <span class="ml-1">
                      {{ app.displayText }}
                    </span>
                  </span>
                  <span v-else>
                    <i
                      class="fa fa-fw fa-circle-o-notch fa-spin text-muted"
                    ></i>
                  </span>
                </button>
                <a
                  v-if="!app.loading && app.isInstalled"
                  class="btn btn-primary btn-sm ml-1 text-uppercase"
                  target="_blank"
                  :href="urls.sso.login(app)"
                >
                  <i class="fa fa-fw fa-sign-in mr-1"></i>
                  Sign In
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { getAllApps, updateMyApps } from '@/api'
import alertify from "alertify.js";
import urls from '@/api/urls'

export default {
  props: {
    categories: {
      type: Array,
      required: true,
    },
    defaultCategory: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      category: this.defaultCategory,
      userApps: [],
      apps: [],
      loading: false,
      urls,
    }
  },

  computed: {
    filteredApps() {
      if (!this.category) {
        return this.apps
      } else {
        return this.apps.filter(app => app.category === this.category)
      }
    }
  },

  watch: {
    category () {
      const url = new URL(document.location.toString())
      url.search = 'category=' + encodeURIComponent(this.category)
      window.history.pushState({}, "", url)
    },
  },

  async mounted () {
    try {
      let response = await getAllApps()
      this.apps = response.data;
      this.apps = response.data.map(app => ({
        ...app, loading: false,
        displayAsInstalled:
        app.isInstalled,
        displayText: app.isInstalled ?  'INSTALLED' : 'ADD'
      }))
      this.loading = false;
    } catch (error) {
      //
    }
  },

  methods: {
    updateLibrary(app, index) {
      if (app.required) {
        alertify.alert(`Sorry, ${app.name} cannot be uninstalled!`);
        return;
      }
      let confirmText = app.isInstalled ? 'remove' : 'install'
      alertify.confirm(`Are you sure you want to ${confirmText} ${app.name}?`, () => {
        app.loading = true;
        let action = app.isInstalled ? 'detach' : 'attach'
        updateMyApps([app], action)
          .then(result => {
            this.apps[index].loading = false
            this.apps[index].isInstalled = !app.isInstalled
            this.apps[index].displayAsInstalled = app.isInstalled
            this.apps[index].displayText = app.isInstalled ? 'INSTALLED' : 'ADD'
          })
      })
    },

    displayText(app, index, action) {
      if(app.required) return;
      if(action === 'mouseover') {
        app.displayAsInstalled = !app.displayAsInstalled;
        if(app.isInstalled) {
          app.displayText = 'REMOVE'
        } else {
          app.displayText = 'ADD'
        }
      } else if(action === 'mouseout') {
        app.displayAsInstalled = !app.displayAsInstalled;
        if(app.isInstalled) {
          app.displayText = 'INSTALLED'
        } else {
          app.displayText = 'ADD'
        }
      }
    }
  }
}
</script>
